import ActivitySlideout from './ActivitySlideout'
export default ActivitySlideout;